import Vue from "vue";
import router from "../router";
import VueGtag from "vue-gtag";

Vue.use(VueGtag, {
  config: { id: "G-Y9SRV3DHYH", params: {'user_id': localStorage.getItem("uid")} }
}, router);
